(ns kyber.components.base.divider
  (:require [kyber.styles.core :refer [styles->classes gs]]))

(def classes
  (styles->classes
   {:base {:border-top (str "1px solid "
                            (gs [:colors :gray-scale-200]))
           :width "100%"
           :padding [[(gs [:spacing :p4])
                      :auto
                      (gs [:spacing :p4])
                      :auto]]}}))

(defn divider
  ([] (divider {}))
  ([{:keys [style]}]
   [:div {:class (:base classes)
          :style style}]))
